<template>
  <base-section id="about-our-product">
    <base-section-heading
      color="grey lighten-2"
      icon="mdi-playlist-check"
      title="Unser Angebot für Sie"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="3"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: 'Buchhaltung',
          subtitle: 'Finanzbuchhaltung',
          text: 'asdfasdfasdf',
          callout: '01',
        },
        {
          title: 'Personalwesen',
          subtitle: 'Lohnbuchhaltung',
          text: 'Similique sunt in culpa qui officia deserunt mollitia animi, id est laborut dolorum fuga.harum quidem rerum facilis estexpedita distinctio.',
          callout: '02',
        },
        {
          title: 'Unternehmensberatung',
          subtitle: 'Unternehmensberatung',
          text: 'Similique sunt in culpa qui officia deserunt mollitia animi, id est laborut dolorum fuga.harum quidem rerum facilis estexpedita distinctio.',
          callout: '03',
        },
        {
          title: 'Steuerberatung',
          subtitle: 'Steuerberatung',
          text: 'Similique sunt in culpa qui officia deserunt mollitia animi, id est laborut dolorum fuga.harum quidem rerum facilis estexpedita distinctio.',
          callout: '04',
        },
      ],
    }),
  }
</script>

<style>
.overridecolor > .grey--text.text--lighten-1{
  color: #000;
}
</style>
